module.exports = __webpack_public_path__ + "01_glasses_red.33a37bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/01_glasses_red.png
// module id = oYke
// module chunks = 0